import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { advisorDTO } from './api-interfaces/api-advisor.interface';
import { HelperService } from '../helperService';
@Injectable({
  providedIn: 'root',
})

export class APIAdvisorService {
  ApiURL: string = '';
  constructor(private http: HttpClient, private helperService: HelperService) {
    this.ApiURL = environment.ServiceAdvisorURL + 'ServiceAdvisors/CreateServiceAdvisorDataJson';
  }
  public post (newAdvisor:advisorDTO):Observable<any>{
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
    const requestOptions = {
        headers: headers,
      };
    return this.http.post<any>(this.ApiURL,newAdvisor,requestOptions)
  }
}

